import { useEffect, useState } from 'react';
import { Paper } from '@mui/material';
import { Grid } from '@ts/storybook';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router';

//@ts-ignore
import logo from '@public/assets/logo/track_sphere_logo_white.svg';
import { appPalette } from '@public/customization/CustomTheme';
import { Button, ResetPasswordForm, NewPasswordForm, Typography } from '@ts/storybook';
import { ELoginState, IAppProps, IRouterProps } from '@interfaces/App.interface';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { useRouterContext } from '@utils/context/RouterContext';
import { postData } from '@redux/slices/functionals/request/requestActions';
import FormContainer from '@pages/DataBase/Flavors/FormContainer';

const useStyles = makeStyles(theme => {
  return {
    containerRecover: {
      height: '100vh',
      backgroundColor: appPalette.primary,
    },
  };
});

interface UserPasswordRecoveryProps extends IAppProps, IRouterProps {
  navigate: any;
}

const PasswordRecoveryPage = (props: UserPasswordRecoveryProps) => {
  const classStyle = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { transferPropsRoute: route } = useRouterContext();
  const token = route?.query?.token;
  const loginState = useAppSelector(state => state.global.loginState);
  const [passwordRecoveryMessages, setPasswordRecoveryMessages] = useState<string>('');

  //#region Functions
  const goToLogin = () => {
    navigate('/login');
  };

  const sendRecoveryPassword = async (v: string) => {
    const response = await dispatch(
      postData({
        url: '/api/passwordRecovery',
        dataBody: { login: v },
        withoutMeta: true,
        withoutMethod: true,
        withoutData: true,
      })
    );
    if (response.payload.data) setPasswordRecoveryMessages(response.payload.data.status);
  };

  const sendNewPassword = async attrs => {
    const { password, passwordConfirmation } = attrs;
    const data = {
      token,
      password,
      passwordConfirmation,
    };
    const response = await dispatch(
      postData({
        url: '/api/passwordReset',
        dataBody: data,
        withoutMeta: true,
        withoutMethod: true,
        withoutData: true,
      })
    );
    if (response.payload.data) setPasswordRecoveryMessages('SUCCESS_RESET');
  };
  //#endregion

  //#region Renders

  const renderMessageBtnLogin = (message: string) => {
    return (
      <Paper className="m-5 inline-block px-6 w-[600px]" elevation={2}>
        <div className="my-6">
          <Grid container spacing={2} mb={4}>
            <Grid size={12}>
              <Typography variant="h6" text="Recover your password" />
            </Grid>
            <Grid size={12}>
              <Typography variant="body1" text={message} />
            </Grid>
            <Grid container justifyContent={'space-around'} size={12}>
              <Button onClick={goToLogin} label="Login" />
            </Grid>
          </Grid>
        </div>
      </Paper>
    );
  };

  const renderAfterSubmit = () => {
    if (passwordRecoveryMessages === 'SUCCESS') {
      return renderMessageBtnLogin('Password recovery succeeded, check your inbox for instructions.');
    }

    if (passwordRecoveryMessages === 'SUCCESS_RESET') {
      return renderMessageBtnLogin('Password reset succeeded, please go to login.');
    }
  };

  const renderContent = () => {
    let content = renderAfterSubmit();
    if (!content) {
      if (!token) {
        content = <ResetPasswordForm onSubmit={sendRecoveryPassword} onCancel={goToLogin} />;
      } else {
        content = <NewPasswordForm token={token} onSubmit={sendNewPassword} FormContainer={FormContainer} />;
      }
    }
    return content;
  };
  //#endregion

  useEffect(() => {
    if (loginState == ELoginState.LOGGED_IN) {
      navigate('/home');
    }
  }, []);

  return (
    <Grid
      container
      id="loginContainer"
      direction="column"
      className={classStyle.containerRecover}
      justifyContent="center"
      alignItems="center"
      m={0}
    >
      <Grid size={'auto'}>
        <div style={{ width: '350px', margin: 'auto' }}>
          <img alt="logo" src={logo} style={{ width: '100%' }} id="logo_img" />
        </div>
        {renderContent()}
      </Grid>
    </Grid>
  );
};

export default PasswordRecoveryPage;
